import React, { useEffect } from 'react';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import { useDispatch, useSelector } from 'react-redux';
import styled from 'styled-components';
import { adminAuth } from '../../store/actions/authAction';

export const AuthForm = (props) => {
  const dispatch = useDispatch();
  const { isAuthenticated, user } = useSelector((state) => state.adminAuth);

  useEffect(() => {
    if (isAuthenticated || user) {
      props.history.push('/admin/dashboard');
    }
  }, [isAuthenticated, user, props.history]);

  return (
    <AuthFormWrapper>
      <div className='form__container'>
        <h1 className='form__title'>
          Welcome Back !, Log in to admin dashboard
        </h1>
        <Formik
          initialValues={{ email: '', password: '' }}
          validate={(values) => {
            const errors = {};
            if (!values.email) {
              errors.email = 'Required';
            } else if (
              !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(values.email)
            ) {
              errors.email = 'Invalid email address';
            }
            return errors;
          }}
          onSubmit={(values, { setSubmitting }) => {
            dispatch(adminAuth(values));
            setSubmitting(false);
          }}
        >
          {({ isSubmitting }) => (
            <Form autoComplete='off' autoSave='off' autoCorrect='off'>
              <div className='input_and_err'>
                <Field type='email' name='email' placeholder='E-mail Address' />
                <ErrorMessage name='email' component='div' className='error' />
              </div>
              <div className='input_and_err'>
                <Field type='password' name='password' placeholder='Password' />
                <ErrorMessage
                  name='password'
                  component='div'
                  className='error'
                />
              </div>
              <button type='submit' disabled={isSubmitting}>
                Submit
              </button>
            </Form>
          )}
        </Formik>
      </div>
    </AuthFormWrapper>
  );
};

const AuthFormWrapper = styled.main`
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  position: relative;

  .form__container {
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
  }

  .form__title {
    font-size: 2rem;
    font-weight: bold;
    color: (theme) => theme.text;
    text-align: center;
    margin-bottom: 3rem;
    text-transform: capitalize;
  }

  .form__container form {
    width: auto;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  .input_and_err {
    margin-bottom: 1rem;
  }

  .error {
    color: red;
    text-align: left;
  }

  .form__container form input {
    width: 100%;
    height: 3rem;
    border: 1px solid ${({ theme }) => theme.a};
    padding: 0 1rem;
    font-size: 1.2rem;
    font-weight: bold;
    color: #000;
    text-align: center;
  }

  .form__container button {
    width: 100%;
    height: 3rem;
    border: 1px solid ${({ theme }) => theme.toggleBorder};
    background: ${({ theme }) => theme.svg};
    color: ${({ theme }) => theme.box_inner};
    text-transform: capitalize;
    font-weight: bold;
  }
`;
